export enum Application {
    MemberApp = 1,
    Admin = 2
}
